import { jsx, jsxs } from 'react/jsx-runtime';
import { ClickAwayListener } from '@mui/base';
import { styled } from '@mui/material';
import clsx from 'clsx';
import { IconButton } from '../../IconButton/IconButton.js';
import '../../Icons/Add.js';
import '../../Icons/Application.js';
import '../../Icons/AppStore.js';
import '../../Icons/Arrow.js';
import '../../Icons/At.js';
import '../../Icons/Attach.js';
import '../../Icons/Bank.js';
import '../../Icons/Battery.js';
import '../../Icons/Bell.js';
import '../../Icons/Blocked.js';
import '../../Icons/Calendar.js';
import '../../Icons/Card.js';
import '../../Icons/CaretDown.js';
import '../../Icons/CaretLeft.js';
import '../../Icons/CaretRight.js';
import '../../Icons/CaretUp.js';
import '../../Icons/Checkbox.js';
import '../../Icons/CheckboxChecked.js';
import '../../Icons/CheckboxIndeterminate.js';
import '../../Icons/ChevronLeft.js';
import '../../Icons/ChevronRight.js';
import '../../Icons/Company.js';
import '../../Icons/Copy.js';
import '../../Icons/Currency.js';
import '../../Icons/Customers.js';
import '../../Icons/Dash.js';
import '../../Icons/Dashboard.js';
import DirectionDown from '../../Icons/DirectionDown.js';
import DirectionUp from '../../Icons/DirectionUp.js';
import '../../Icons/Document.js';
import '../../Icons/DoubleChevronLeft.js';
import '../../Icons/DoubleChevronRight.js';
import '../../Icons/DoubleDirectionDown.js';
import '../../Icons/DoubleDirectionUp.js';
import '../../Icons/Download.js';
import '../../Icons/Edit.js';
import '../../Icons/ExclamationMark.js';
import '../../Icons/ExclamationMarkFilled.js';
import '../../Icons/ExternalLink.js';
import '../../Icons/EyeClosed.js';
import '../../Icons/EyeOpen.js';
import '../../Icons/Fingerprint.js';
import '../../Icons/Folder.js';
import '../../Icons/Forever.js';
import '../../Icons/Funnel.js';
import '../../Icons/GooglePlay.js';
import '../../Icons/Iban.js';
import '../../Icons/Id.js';
import '../../Icons/Info.js';
import '../../Icons/InfoFilled.js';
import '../../Icons/Instant.js';
import '../../Icons/Ip.js';
import '../../Icons/Link.js';
import '../../Icons/List.js';
import '../../Icons/Mail.js';
import '../../Icons/Menu.js';
import '../../Icons/Message.js';
import '../../Icons/MessageDot.js';
import '../../Icons/Onboarding.js';
import '../../Icons/Padlock.js';
import '../../Icons/PadlockOpen.js';
import '../../Icons/Percent.js';
import '../../Icons/Play.js';
import '../../Icons/PowerOff.js';
import '../../Icons/ProcessCompleted.js';
import '../../Icons/ProcessCountEight.js';
import '../../Icons/ProcessCountFive.js';
import '../../Icons/ProcessCountFour.js';
import '../../Icons/ProcessCountNineAndMore.js';
import '../../Icons/ProcessCountOne.js';
import '../../Icons/ProcessCountSeven.js';
import '../../Icons/ProcessCountSix.js';
import '../../Icons/ProcessCountThree.js';
import '../../Icons/ProcessCountTwo.js';
import '../../Icons/ProcessFailed.js';
import '../../Icons/ProcessInProgress.js';
import '../../Icons/ProcessNotStarted.js';
import '../../Icons/ProcessPartialInProgress.js';
import '../../Icons/ProcessPaused.js';
import '../../Icons/Profile.js';
import '../../Icons/Progress.js';
import '../../Icons/Provider.js';
import '../../Icons/QuestionMark.js';
import '../../Icons/QuestionMarkFilled.js';
import '../../Icons/Remove.js';
import '../../Icons/Repeat.js';
import '../../Icons/Reset.js';
import '../../Icons/RoundArrow.js';
import '../../Icons/RoundArrowFilled.js';
import '../../Icons/RoundCheckOutlined.js';
import '../../Icons/RoundCheckOutlinedFilled.js';
import '../../Icons/RoundClose.js';
import '../../Icons/RoundCloseFilled.js';
import '../../Icons/RoundLeft.js';
import '../../Icons/RoundLeftFilled.js';
import '../../Icons/RoundMinus.js';
import '../../Icons/RoundMinusFilled.js';
import '../../Icons/RoundPlus.js';
import '../../Icons/RoundPlusFilled.js';
import '../../Icons/RoundRight.js';
import '../../Icons/RoundRightFilled.js';
import '../../Icons/Settings.js';
import '../../Icons/SettingsCog.js';
import '../../Icons/Shield.js';
import '../../Icons/StarFilled.js';
import '../../Icons/StarOutlined.js';
import '../../Icons/Success.js';
import '../../Icons/Timer.js';
import '../../Icons/Trash.js';
import '../../Icons/Upload.js';
import '../../Icons/User.js';
import '../../Icons/VerticalDots.js';
import '../../Icons/World.js';
import '../../Icons/Wrench.js';
import '../../Icons/Zoom.js';
import { ListBox, LIST_BOX_CLASSES } from '../../Listbox/ListBox.js';
import { useYearPicker } from './useYearPicker.js';

function YearPicker({ yearsOffset, onChangeYear, monthDate }) {
    const { toggleActive, deactivate, handleYearClick, currentYear, yearsOptions, getListboxProps, isOpenDropdown, handleFocusLeavingList, handleKeyDown, targetItemRef, } = useYearPicker({
        onChangeYear,
        yearsOffset,
        monthDate,
    });
    return (jsx(ClickAwayListener, { onClickAway: deactivate, children: jsxs(ListBoxWrapper, { children: [jsx(IconButton, { buttonSize: 20, variant: "high", onClick: toggleActive, children: isOpenDropdown ? jsx(DirectionUp, {}) : jsx(DirectionDown, {}) }), jsx(StyledListBox, Object.assign({}, getListboxProps(), { className: clsx({ [LIST_BOX_CLASSES.hidden]: !isOpenDropdown }), tabIndex: -1, onBlur: handleFocusLeavingList, children: yearsOptions.map((option) => (jsx(StyledListboxItem, { className: clsx({ highlighted: option.value === currentYear }), ref: option.value === currentYear ? targetItemRef : null, tabIndex: 0, onClick: handleYearClick(option.value), onKeyDown: handleKeyDown(option.value), children: option.label }, option.value))) }))] }) }));
}
const ListBoxWrapper = styled("div")({
    position: "relative",
});
const DROPDOWN_WIDTH = 120;
const DROPDOWN_HEIGHT = 232;
const StyledListBox = styled(ListBox)({
    top: 30,
    right: 0,
    width: DROPDOWN_WIDTH,
    maxHeight: DROPDOWN_HEIGHT,
    overflow: "auto",
    "& > li": {
        "&[aria-selected='true']": {
            backgroundColor: "transparent",
        },
        ":focus": {
            // https://supercharged.atlassian.net/browse/MP-1611
            backgroundColor: "rgba(27, 99, 207, 0.05)",
        },
    },
    "&.hidden": {
        transition: "none",
    },
});
const StyledListboxItem = styled("li")(({ theme }) => ({
    "&.highlighted": {
        color: theme.palette.text.highlight,
        fontWeight: 500,
    },
}));

export { YearPicker };
//# sourceMappingURL=YearPicker.js.map
